<template>
  <div v-if="saveMore"
       class="product-detail-vip-benefit-bar"
       :class="{ 'fixed': fixed }"
  >
    <div class="product-detail-vip-benefit-bar-left">
      {{ saveMore.hint }}<span>{{ saveMore.amount }}元</span>
    </div>
    <div class="product-detail-vip-benefit-bar-right"
         @click="handleClickJoin"
    >
      <span>立即加入</span>
      <ym-icon name="right"
               size="8"
               :color="fixed ? '#fff' : '#666'"
      />
    </div>
  </div>
</template>

<script>
  import { before, decorator } from 'ym-reporter-vue';

  export default {
    name: 'ProductDetailVipBenefitBar',
    props: {
      fixed: Boolean,
      saveMore: Object,
      tabSelected: String,
    },
    data() {
      return {};
    },
    methods: {
      @decorator(before(function () {
        this.$reporter.report('COURSE_DETAIL_ATONCE_JOINVIP_CLICK', { location: this.tabSelected });
      }))
      handleClickJoin() {
        window.sessionStorage.setItem('pay-origin-info', JSON.stringify({
          path: this.$route.fullPath,
          action: 'course-detail-join',
          location: this.tabSelected,
        }));
        this.$router.push({ name: 'VipDetail', params: { id: 1 } });
      },
    },
    created() {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-vip-benefit-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 26px;
    border-radius: 4px;
    background-color: #fff6ce;
    width: 100%;
    height: 60px;
    margin-top: 40px;
    &-left {
      color: @color-black-dark;
      font-size: 26px;
      font-weight: @font-weight-bold;
      span {
        color: #ff0f0f;
      }
    }
    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-light;
      font-size: 22px;
      span:first-child {
        margin-right: 8px;
      }
    }
    &.fixed {
      padding-left: 60px;
      padding-right: 40px;
      margin-top: 0;
      .product-detail-vip-benefit-bar-right {
        width: 134px;
        height: 40px;
        border-radius: 10px;
        background: linear-gradient(90deg, #474747 0%, #222222 100%);
        color: @color-white;
        span:first-child {
          margin-left: 8px;
          margin-right: 0;
        }
      }
    }
  }
</style>
